import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { ITinhTrangNoMonRequest } from "../../../model/request/tinh-trang-no-mon/ITinhTrangNoMonRequest";
import { ITinhTrangNoMonViewModel } from "../../../model/response/tinh-trang-no-mon/ITinhTrangNoMonViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTinhTrangNoMonActionsObj = {
    LOAD_START: {} as ITinhTrangNoMonRequest,
    LOAD_SUCCESS: {} as ITinhTrangNoMonViewModel[],
    LOAD_ERROR: "",

    CHANGE_FOCUSED_VALUE_LOP: {} as ITreeviewLopFocusedValue,
    CHANGE_FOCUSED_TAB_CHANGE: {} as "tat-ca" | "sinh-vien-no-mon" | "du-dieu-kien-chua-xet-tot-nghiep",

    CHANGE_SELECTED_TRANG_THAI_HOC: [] as number[],
    CHANGE_SELECTED_ID_SVS: {} as number[],
}

export const eTinhTrangNoMonActionIds = generateActionTypeIds(eTinhTrangNoMonActionsObj, "TINH_TRANG_NO_MON");
export type ITinhTrangNoMonActionTypes = IGenericActionType<typeof eTinhTrangNoMonActionsObj, "TINH_TRANG_NO_MON">;